var module = angular.module('octopusApp.infrastructure');

module.filter('extension', function () {
  return function (input) {
    return input.split('.').pop().toLowerCase();
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/filters/extension.js
// module id = 687
// module chunks = 1